import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getTranslationKeyForNode } from '../utils/labelUtils';
import {
    buildConnectingLineClassName,
    buildNodeClassName,
} from '../utils/nodeUtilities';
import NodeIcon from './NodeIcon';

export default function StationNode(props) {
    const { t } = useTranslation(['bagSummary']);
    const nodeClassName = buildNodeClassName(props.node);
    const nodeLineClassName = buildConnectingLineClassName(props.node.style);
    const nodeLabel = t(getTranslationKeyForNode(props.node));

    function FormattedNodeTimeStamp({ timestamp }) {
        if (!timestamp) {
            return '';
        }
        return (
            <div className="station-node__timestamp">
                {moment(timestamp).format('DDMMM - HH:mm[L]').toUpperCase()}
            </div>
        );
    }

    return (
        <div className={nodeClassName}>
            <NodeIcon node={props.node} />
            <div
                className={nodeLineClassName}
                style={{ width: props.lineLength }}
            />
            <div
                className="station-node__info"
                style={{ width: `calc(${props.lineLength} * 0.8}` }}
            >
                <div className="station-node__description">{nodeLabel}</div>
                <FormattedNodeTimeStamp timestamp={props.node.timestamp} />
            </div>
        </div>
    );
}
